module.exports = __webpack_public_path__ + "static/media/tacconi.bb5461f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/tacconi.png
// module id = 965
// module chunks = 0